<template>
  <div>
    <div
      v-if="isWorkerDocVerifyFailed"
      class="fail-message-style mb-4"
    >
      <p
        v-for="(item, i) in workerDocVerificationStatus.expired_documents"
        :key="i"
        class="fail-style"
      >
        <v-icon
          color="#C62828"
          size="30"
        >
          mdi-alert
        </v-icon> <br>
        '{{ item.document_type.name }}' is expired, please upload the renewed file.
      </p>
    </div>
    <div
      v-if="verificationFailed"
      class="fail-message-style mb-4"
    >
      <p class="fail-style">
        <v-icon
          color="#C62828"
          size="30"
        >
          mdi-alert
        </v-icon> <br>
        {{ verificationFailedMessage }}
      </p>
    </div>
    <div class="header-section">
      <div>
        <h1 class="header-style">
          Work Type
        </h1>
        <br>
        <p class="subheader-style">
          Select a work type for further process
        </p>
      </div>
    </div>
    <br>
    <div>
      <v-card color="#F8F8F8">
        <v-card-text>
          <h3>Select Your Work Type</h3>
          <br>
          <br>
          <v-form
            ref="form"
            v-model="valid"
          >
            <div>
              <v-radio-group
                v-model="workType"
                row
                light
                class="radio-group-style"
                :rules="[(v) => !!v || 'This field is required']"
                @change="isWorkTypeChanged"
              >
                <v-radio
                  label="Construction Work"
                  value="project-work"
                  light
                  class="value-text-style"
                  color="#FF3700"
                >
                  <template #label>
                    <p class="type-bottom">
                      Construction Work
                    </p>
                  </template>
                </v-radio>
                <v-radio
                  label="Issue Fix"
                  value="project-issue"
                  class="value-text-style"
                  light
                  color="#FF3700"
                >
                  <template #label>
                    <p class="type-bottom">
                      Issue Fix
                    </p>
                  </template>
                </v-radio>
              </v-radio-group>
            </div>
            <div v-if="isBudgetTypeSelected">
              <v-autocomplete
                v-model="selectedBudgetItem"
                :items="projectBudgets"
                item-value="id"
                color="#37474F"
                filled
                outlined
                dense
                class="field-text-style"
                light
                item-text="name"
                :rules="[(v) => !!v || 'This field is required']"
                label="Select Work Item"
                prepend-icon="mdi-account-hard-hat"
                hint="Select your work item from the available list for continuing the check-in process."
                persistent-hint
                @input="getSelectedBudgetDetails()"
              />
            </div>

            <div v-if="isIssueTypeSelected">
              <v-autocomplete
                v-model="selectedProjectIssue"
                :items="projectIssues"
                item-value="id"
                color="#37474F"
                filled
                outlined
                dense
                class="field-text-style"
                light
                item-text="title"
                :rules="[(v) => !!v || 'This field is required']"
                label="Select Issue"
                prepend-icon="mdi-tools"
                hint="Select a project issue from this available list for continuing the check-in process."
                persistent-hint
                @input="getSelectedIssueDetails()"
              />
            </div>
          </v-form>
        </v-card-text>
      </v-card>
      <br>
      <v-card-actions>
        <v-spacer />
        <v-btn
          class="next-style"
          elevation="0"
          @click="next()"
        >
          Next
        </v-btn>
        <v-btn
          class="cancel-style"
          elevation="0"
          @click="cancel()"
        >
          Cancel
        </v-btn>
      </v-card-actions>
    </div>
    <centre-spinner :loading="loading" />
    <budget-instances
      v-if="showInstancesForm"
      @store-instance="saveInstanceDetails"
      @closed="showInstancesForm = false"
    />
  </div>
</template>

<script>
import spinner from 'src/views/components/SpinnerCentre';
import Constants from 'src/constants';
import BudgetInstances from '../dialogs/BudgetInstances.vue';
export default {
  name: 'SelectProject',
  components: {
    'centre-spinner': spinner,
    'budget-instances': BudgetInstances,
  },
  async beforeRouteLeave (to, from, next) {
    await this.clearAll();
      next();
  },
  props: {
    projectId: {
      type: String,
      default: null,
    },
  },
  data () {
    return {
      loading: false,
      isBudgetTypeSelected: false,
      isIssueTypeSelected: false,
      selectedBudgetItem: '',
      selectedProjectIssue: '',
      workType: 'project-work',
      valid: false,
      verificationFailed: false,
      verificationFailedMessage: '',
      showInstancesForm: false,
    };
  },
  computed: {
    projectBudgets () {
      return this.$store.getters['devices/getProjectBudgets'];
    },
    projectIssues () {
      return this.$store.getters['devices/getProjectIssues'];
    },
    deviceData () {
      return this.$store.getters.getDeviceData;
    },
    appUserCheckInRecord () {
      return this.$store.getters['devices/getActiveCheckInDetails'];
    },
    checkOutType () {
      return this.$store.getters['devices/getCheckOutType'];
      },
      workerDocVerificationStatus () {
        return this.$store.getters['devices/getWorkerDocVerifyStatus'];
      },
      isWorkerDocVerifyFailed () {
        if (Object.keys(this.workerDocVerificationStatus).length > 0 && this.workerDocVerificationStatus.verification_status === 'failed') {
          return true;
        }
        return false;
      },
      orgSettings () {
        return this.$store.getters['devices/getOrganizationSettings'];
      },
    budgetInstances () {
        return this.$store.getters['devices/getBudgetInstances'];
      },
  },
  async mounted () {
    this.isWorkTypeChanged();
    await this.clearData();
    await this.fetchProjectBudgets();
    await this.fetchProjectIssues();
    await this.fetchOrgDetails();
  },
  methods: {
    async fetchProjectBudgets () {
      this.loading = true;
      await this.$store.dispatch('devices/fetchProjectBudgets', {
        projectId: this.projectId ? this.projectId : this.appUserCheckInRecord.project.id,
      });
      this.loading = false;
    },
    async fetchProjectIssues () {
      this.loading = true;
      await this.$store.dispatch('devices/fetchProjectIssues', {
        paramData: {
          params: {
             status: ['pending', 'active'],
          },
        },
        projectId: this.projectId ? this.projectId : this.appUserCheckInRecord.project.id,
      });
      this.loading = false;
    },
    isWorkTypeChanged () {
      this.$store.dispatch('devices/clearSavedWorkDetails');
      if (this.workType === 'project-work') {
        this.isIssueTypeSelected = false;
        this.selectedProjectIssue = '';
        this.isBudgetTypeSelected = true;
      } else {
        this.isBudgetTypeSelected = false;
        this.selectedBudgetItem = '';
        this.isIssueTypeSelected = true;
      }
    },
    async getSelectedBudgetDetails () {
      this.loading = true;
      const budgetDetails = this.projectBudgets.find(
        budget => budget.id === this.selectedBudgetItem,
      );
      await this.$store.dispatch('devices/saveSelectedWorkDetails', {
        details: budgetDetails,
        workType: 'project-work',
      });
      this.loading = false;
    },
    async getSelectedIssueDetails () {
      this.loading = true;
      const issueDetails = this.projectIssues.find(
        issue => issue.id === this.selectedProjectIssue,
      );
      await this.$store.dispatch('devices/saveSelectedWorkDetails', {
        details: issueDetails,
        workType: 'project-issue',
      });
      this.loading = false;
    },
    async next () {
      if (this.$refs.form.validate() === false) {
        this.$store.dispatch('alert/onAlert', {
          message: 'Please fill the required fields before proceeding',
          type: Constants.ALERT_TYPE_ERROR,
        }, { root: true });
        return;
      }
      this.loading = true;
      if (this.orgSettings.settings.document_verification) {
            this.$store.dispatch('devices/verifyDocuments', {
            organizationExtId: this.deviceData.organization_id.external_id,
          }).then(response => {
            this.loading = false;
            if (this.isWorkerDocVerifyFailed === true) {
              setTimeout(() => {
                this.loading = true;
            this.$store.dispatch('devices/workerLogout');
            this.$router.push({ name: 'DeviceCheckInCheckOut' });
            this.loading = false;
          }, 3000);
              return;
            }
            this.verified();
          }).catch(error => {
            this.loading = false;
            this.verificationFailed = true;
            this.verificationFailedMessage = error.response.data.message;
          });
          } else {
            this.verified();
          }
    },
    async verified () {
      if (this.workType === 'project-work') {
        await this.$store
        .dispatch('devices/verifyWorkDetail', {
            organizationExtId: this.deviceData.organization_id.external_id,
            details: {
              type: 'project-work',
              budget_id: this.selectedBudgetItem,
              issue_id: null,
            },
          }).then((response) => {
            this.getBudgetInstances();
          })
          .catch(error => {
            this.loading = false;
            this.verificationFailed = true;
            this.verificationFailedMessage = error.response.data.message;
          });
        return;
      }
      await this.$store
        .dispatch('devices/verifyWorkDetail', {
          organizationExtId: this.deviceData.organization_id.external_id,
          details: {
            type: 'project-issue',
            issue_id: this.selectedProjectIssue,
            budget_id: null,
          },
        })
        .then(response => {
          this.loading = false;
          this.$emit('selected-work-type');
        })
        .catch(error => {
          this.loading = false;
          this.verificationFailed = true;
          this.verificationFailedMessage = error.response.data.message;
        });
    },
          async getBudgetInstances () {
        await this.$store.dispatch('devices/fetchBudgetInstances', {
          budgetId: this.selectedBudgetItem,
        }).then(response => {
          if (this.budgetInstances.length === 1) {
            const instanceId = this.budgetInstances[0].id;
            this.$store.dispatch('devices/saveSelectedInstanceDetails', instanceId);
            this.loading = false;
            this.$emit('selected-work-type');
          } else if (this.budgetInstances.length > 1) {
            this.loading = false;
            this.showInstancesForm = true;
          } else {
            this.loading = false;
            this.$emit('selected-work-type');
          }
        }).catch(error => {
          this.loading = false;
          this.verificationFailed = true;
          this.verificationFailedMessage = error.response.data.message;
        });
      },
      async fetchOrgDetails () {
        await this.$store.dispatch('devices/fetchOrganizationSettings', this.deviceData.organization_id.external_id);
      },
    cancel () {
      this.loading = true;
      setTimeout(() => {
        this.$emit('cancel');
      }, 1000);
    },
    saveInstanceDetails (instanceId) {
        this.loading = true;
        setTimeout(() => {
          this.$store.dispatch('devices/saveSelectedInstanceDetails', instanceId);
          this.loading = false;
          this.$emit('selected-work-type');
        }, 1000);
      },
      async clearData () {
await this.$store.dispatch('devices/clearDocVerifyData');
await this.$store.dispatch('devices/clearSavedWorkDetails');
      },
  },
};
</script>

<style scoped>
.header-section {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.short-letter-style {
  color: white;
}

.v-card {
  padding: 15px 20px;
  border-radius: 10px;
}

.type-bottom {
  margin-bottom: 0px;
}
.theme--dark.v-list{
  background-color: white!important;
}
.theme--dark >>> .v-list-item{
  color:#37474F!important;
}
.next-style,
.cancel-style {
  width: 100px;
  height: 40px !important;
}

.next-style {
  background: #37474f !important;
}

.cancel-style {
  background: #e2e2e2 !important;
  color: #37474f;
}
.checkin .mdi-checkbox-marked::before{
  color: #37474F !important;
  caret-color: #37474F !important;
}
::v-deep .v-input--selection-controls__input .v-icon {
  color: #37474F !important;
}
</style>
